import React from "react";
import { lineSpinner } from "ldrs";
import ProgessLoader from "../progressLoader";
import { AiFillBulb } from "react-icons/ai";

lineSpinner.register();

const ComponentLoader = ({ percentage, message, tip }) => {
  return (
    <div className="fixed left-[50%] top-[50%] -translate-x-1/2 -translate-y-1/2  z-[100] h-fit w-fit max-w-[350px]    ">
      {percentage ? (
        <div className="h-fit  w-fit items-center rounded-lg bg-pri-clr-blue border-[1px] border-[#634fbc] p-2 text-center">
          <p className=" text-center text-[17px] font-[650] text-white">
            {percentage === "0.00" ? "Please wait..." : message}
          </p>{" "}
          <div>
            <ProgessLoader loaderWidth={percentage} />
          </div>
          {percentage && (
            <p className=" text-center text-[17px] font-[650] text-white">
              {percentage !== "0.00" && `${percentage}%`}
            </p>
          )}
          {percentage !== "0.00" && (
            <div className="flex justify-start items-start">  
              <AiFillBulb className="text-[40px] mt-[-7px] text-white " />
              <p className=" flex items-start text-left text-[14px] font-[400] text-white">
                {tip}
              </p>
            </div>
          )}
        </div>
      ) : (
        <l-line-spinner
          size="60"
          stroke="6"
          speed="1"
          color="#231c42"
        ></l-line-spinner>
      )}
    </div>
  );
};

export default ComponentLoader;
